import { render, staticRenderFns } from "./leavestatustable.vue?vue&type=template&id=f5ad31f6"
import script from "./leavestatustable.js?vue&type=script&lang=js&external"
export * from "./leavestatustable.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports